var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardFocused(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 1.4735V2.78929H8.86843V1.4735H11.5ZM4.92106 1.4735V5.42087H2.28948V1.4735H4.92106ZM11.5 6.73666V10.684H8.86843V6.73666H11.5ZM4.92106 9.36824V10.684H2.28948V9.36824H4.92106ZM12.8158 0.157715H7.55264V4.10508H12.8158V0.157715ZM6.23685 0.157715H0.973694V6.73666H6.23685V0.157715ZM12.8158 5.42087H7.55264V11.9998H12.8158V5.42087ZM6.23685 8.05245H0.973694V11.9998H6.23685V8.05245Z",
    fill: "#12BFE0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardFocused);
export default __webpack_public_path__ + "static/media/dashboardFocused.39fb7b17246e3e702ab25e430bdba29c.svg";
export { ForwardRef as ReactComponent };